'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.flashMessage = flashMessage;
exports.addFlashMessage = addFlashMessage;
exports.removeFlashMessage = removeFlashMessage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = exports.initialState = {
  messages: []
};

function flashMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'REDUX_FLASH_MESSAGE.ADD_FLASH_MESSAGE':
      {
        var _messages = [].concat((0, _toConsumableArray3.default)(state.messages), [action.flashMessage]);
        return (0, _extends3.default)({}, state, { messages: _messages });
      }

    case 'REDUX_FLASH_MESSAGE.REMOVE_FLASH_MESSAGE':
      {
        var _flashMessageId = action.flashMessageId;

        var _messages2 = state.messages.filter(function (f) {
          return _flashMessageId !== f.id;
        });
        return (0, _extends3.default)({}, state, { messages: _messages2 });
      }

    default:
      {
        return state;
      }
  }
}

function addFlashMessage(flashMessage) {
  return { type: 'REDUX_FLASH_MESSAGE.ADD_FLASH_MESSAGE', flashMessage: flashMessage };
}

function removeFlashMessage(flashMessageId) {
  return { type: 'REDUX_FLASH_MESSAGE.REMOVE_FLASH_MESSAGE', flashMessageId: flashMessageId };
}